import { Capacitor } from '@capacitor/core';

/*
  SITE SURUMU TAKIBI
  ------------------
  SORUN: uygulama siteyi internetten yukluyor (capacitor.config server.url).
  Sayfa bir kez yuklendikten sonra uygulama gunlerce acik kalabiliyor ve
  yayinlanan duzeltmeler o telefona HIC ULASMIYOR. Kullanicinin uygulamayi
  tamamen kapatip acmasi gerekiyordu; bunu bilmesi ve her seferinde
  yapmasi beklenemez. 2026-09-28'de arka arkaya yayinlanan bes duzeltme
  bu yuzden telefonda gorunmedi.

  COZUM: uygulama one geldiginde sunucudaki index.html okunup icindeki
  ana betik adina bakiliyor. Ad degismisse yeni bir surum yayinlanmis
  demektir ve sayfa bir kez yeniden yukleniyor.

  NEDEN index.html: her yayinda betik adi degisiyor (main.<hash>.js) ve
  index.html zaten onbelleklenmiyor. Ayri bir surum dosyasi tutmaya,
  dolayisiyla yayin adimina bir sey eklemeye gerek kalmiyor.

  SONSUZ YENILEME KORUMASI: hangi surum icin yenilendigi sessionStorage'a
  yaziliyor. Ayni surum icin ikinci kez yenileme yapilmiyor -- beklenmedik
  bir durumda uygulama kendini surekli yenileyip kullanilamaz hale gelmesin.

  OTURUM KAYBOLMAZ: jeton localStorage'da duruyor, yeniden yukleme onu
  etkilemiyor.
*/

const ANAHTAR_SON = 'surumSonYenilenen';
const EN_AZ_ARALIK_MS = 60 * 1000;   // ayni dakika icinde tekrar sorma

let sonBakis = 0;

const yerli = () =>
  typeof Capacitor?.isNativePlatform === 'function' && Capacitor.isNativePlatform();

/** Sayfayi su an calistiran ana betigin adi. */
const calisanSurum = () => {
  try {
    const betikler = Array.from(document.querySelectorAll('script[src]'));
    for (const b of betikler) {
      const e = /main\.[a-z0-9]+\.js/.exec(b.getAttribute('src') || '');
      if (e) return e[0];
    }
  } catch (e) { /* yoksay */ }
  return null;
};

/** Sunucudaki index.html'in isaret ettigi ana betik adi. */
const sunucudakiSurum = async () => {
  try {
    const cevap = await fetch(`/index.html?s=${Date.now()}`, { cache: 'no-store' });
    if (!cevap.ok) return null;
    const metin = await cevap.text();
    const e = /main\.[a-z0-9]+\.js/.exec(metin);
    return e ? e[0] : null;
  } catch (e) {
    return null;   // internet yoksa hicbir sey yapma
  }
};

const kontrolEt = async () => {
  const simdi = Date.now();
  if (simdi - sonBakis < EN_AZ_ARALIK_MS) return;
  sonBakis = simdi;

  const calisan = calisanSurum();
  if (!calisan) return;

  const sunucudaki = await sunucudakiSurum();
  if (!sunucudaki || sunucudaki === calisan) return;

  // Bu surum icin daha once yenilendiyse tekrar yenileme.
  try {
    if (sessionStorage.getItem(ANAHTAR_SON) === sunucudaki) return;
    sessionStorage.setItem(ANAHTAR_SON, sunucudaki);
  } catch (e) { /* yoksay */ }

  window.location.reload();
};

export const surumTakibiniBaslat = async () => {
  if (!yerli()) return;

  // Acilista bir kez.
  kontrolEt();

  try {
    const { App } = await import('@capacitor/app');
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) kontrolEt();
    });
  } catch (e) { /* eklenti yoksa yalnizca acilis kontrolu kalir */ }
};
